import { render } from "./StatisticRoom.vue?vue&type=template&id=0811d647"
import script from "./StatisticRoom.vue?vue&type=script&lang=js"
export * from "./StatisticRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__